/*
    Note:
    
    The function checks for the availability of the Chatty SDK (`window.$chatty`)
    and retries every 500ms for up to 10 seconds (20 attempts), as the app may
    take time to fully load.

    Once available, it attaches event listeners to track when the chat is opened
    and closed, and publishes corresponding events to Shopify analytics.
*/


function initChattyTracking(attempts = 0) {
    if (attempts > 20) return;
    if (!window.$chatty) {
        setTimeout(() => initChattyTracking(attempts + 1), 500);
        return;
    }
    $chatty.on('chat:opened', function() {
        Shopify.analytics.publish("chatty_chat_opened", {
            timestamp: new Date().toISOString(),
        });
    });
    $chatty.on('chat:closed', function() {
        Shopify.analytics.publish("chatty_chat_closed", {
            timestamp: new Date().toISOString(),
        });
    });
}

let stockistInitialized = false;

function initStockistListener(attempts = 0) {
    if (stockistInitialized) return;
    if (attempts > 20) return;
    const input = window?.Stockist?.__widget?._form?._input;

    if (!input) {
        setTimeout(() => initStockistListener(attempts + 1), 500);
        return;
    }

    stockistInitialized = true;

    let debounceTimer;
    let lastSearch = "";

    input.addEventListener("input", () => {
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            const value = input.value.trim();
            if (!value || value === lastSearch) return;

            lastSearch = value;

            Shopify.analytics.publish("store_locator_search", {
                search_term: value,
                timestamp: new Date().toISOString(),
            });
        }, 2000);
    });
}

document.addEventListener('theme:product:add', (e) => {
    const btn = e.detail?.button;
    if (!btn) return;

    const form = btn.closest('[data-product-form]');
    if (!form) return;

    const isSampleInput = form.querySelector('[name="properties[_is_sample]"]');
    if (!isSampleInput) return;

    Shopify.analytics.publish("swatch_request", {
        timestamp: new Date().toISOString(),
    });
});

document.addEventListener('cf:field_changed', function(event) {
    Shopify.analytics.publish("trade_application_started", {
        timestamp: new Date().toISOString(),
    });
}, {
    once: true
});

document.addEventListener('cf:form_submitted', function(event) {
    const formId = event.detail.formId;
    Shopify.analytics.publish("trade_application_submitted", {
        timestamp: new Date().toISOString(),
        formId,
    });
});

function initDesignerLoginTracking() {
  if (!window.__customerLoggedIn) {
    localStorage.removeItem('designer_login_tracked');
    return;
  }

  const customerTags = window.__customerTags || [];
  if (!customerTags.includes('Designer') && !customerTags.includes('designer')) return;

  const customerId = String(window.__customerId);

  if (localStorage.getItem('designer_login_tracked') === customerId) return;

  localStorage.setItem('designer_login_tracked', customerId);

  Shopify.analytics.publish('designer_login', {
    timestamp: new Date().toISOString(),
    user_id: window.__customerId
  });
}

function initDealerLoginTracking() {
  if (!window.__customerLoggedIn) {
    localStorage.removeItem('dealer_login_tracked');
    return;
  }

  const customerTags = window.__customerTags || [];
  if (!customerTags.includes('Dealer') && !customerTags.includes('dealer')) return;

  const customerId = String(window.__customerId);

  if (localStorage.getItem('dealer_login_tracked') === customerId) return;

  localStorage.setItem('dealer_login_tracked', customerId);

  Shopify.analytics.publish('dealer_login', {
    timestamp: new Date().toISOString(),
    user_id: window.__customerId
  });
}

document.addEventListener("DOMContentLoaded", function() {
    initChattyTracking();
    initStockistListener();
    initDesignerLoginTracking();
    initDealerLoginTracking();

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) {
    if (swat.evtLayer) {
        swat.evtLayer.addEventListener('sw:addedtowishlist', function(e) {
        Shopify.analytics.publish("added_to_wishlist", {
            product_id: e.detail?.d?.empi,
            timestamp: new Date().toISOString(),
        });
        });

        swat.evtLayer.addEventListener('sw:removedfromwishlist', function(e) {
        Shopify.analytics.publish("removed_from_wishlist", {
            product_id: e.detail?.d?.empi,
            timestamp: new Date().toISOString(),
        });
        });
    }
    });
});